import PositionsService from '@/services/api/positions.services'

const state = {
    positions: [],
}

const mutations = {
    SET_POSITIONS(state, payload) {
        state.positions = payload
    },
}

const actions = {
    getPositions({ commit }) {
        return new Promise((resolve, reject) => {
            PositionsService.get('positions')
                .then((response) => {
                    commit('SET_POSITIONS', response.data.data || [])
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    createPosition(context, payload) {
        return new Promise((resolve, reject) => {
            PositionsService.post('positions', {}, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    updatePosition(context, { id, ...payload }) {
        return new Promise((resolve, reject) => {
            PositionsService.put('changePosition', id, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    deletePosition(context, id) {
        return new Promise((resolve, reject) => {
            PositionsService.delete('changePosition', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getPositions: (state) => state.positions,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
